import _ from "lodash";

class Community {
	// CASL subject type detection
	static get modelName() {
		return "Community";
	}

	constructor({ id, identifier, name, url, data }) {
		this.id = id;
		this.identifier = identifier;
		this.name = name;

		// Urls are a stringified JSON array
		// (ex. "['https://s3.amazonaws.com/k4connect-shared/logos/community.png']")
		try {
			this.iconUrl = _.first(JSON.parse(url));
		} catch (e) {
			this.iconUrl = null;
		}

		try {
			this.data = JSON.parse(data);
		} catch (e) {
			this.data = null;
		}
	}
}

export function createCommunity(item) {
	return Object.freeze(new Community(item));
}
